import React from 'react';

const Integritetspolicy = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <h1 className="text-3xl font-bold mb-8 text-minnestig-teal">Integritetspolicy</h1>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">1. Inledning</h2>
        <p className="text-gray-700 leading-relaxed">
          Vi på Demenshjältar värnar om din integritet. I denna policy beskriver vi vilka
          personuppgifter vi samlar in, varför vi gör det och hur du kan ha kontroll över din information.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">2. Vilken information samlar vi in?</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Vi samlar uppgifter såsom namn och e-postaddress men även annan information beroende på formulär.
        </p>
        <p className="text-gray-700 leading-relaxed">
          Vi använder även Google Analytics för att anonymt förstå hur besökare använder vår
          webbplats, men samlar inte IP-adresser eller andra identifierbara uppgifter.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">3. Hur samlar vi in informationen?</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Uppgifterna samlas in när du:
        </p>
        <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-2">
          <li>Fyller i något av våra kontaktformulär</li>
          <li>Besöker vår webbplats (via Google Analytics)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">4. Varför samlar vi in personuppgifter?</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Vi samlar in dina uppgifter för att:
        </p>
        <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-2">
          <li>Kunna kontakta dig om du själv efterfrågat det (t.ex. via formulär)</li>
          <li>Skicka information om MinneStig om du har anmält dig till väntelistan</li>
          <li>Förstå hur många som besöker vår hemsida och hur de hittar oss (via Google Analytics)</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">5. Tredje parter vi delar data med</h2>
        <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-2 mb-4">
          <li>Mailchimp – hanterar vår e-postlista för nyhetsbrev och kontaktformulär och är <b>essentiella</b> för att dessa funktioner ska fungera på hemsidan. Deras <a href="https://mailchimp.com/legal/terms/" target="_blank" rel="noopener noreferrer" className="text-minnestig-purple hover:underline">GDPR-policy</a> gäller.</li>
          <li>Google Analytics – används för anonym statistik om webbplatsbesök men är <b> inte essentiella</b> för hemsidan.</li>
        </ul>
        <p className="text-gray-700 leading-relaxed">
          Vi säljer aldrig din information till tredje part.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">6. Hur länge sparas dina uppgifter?</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Vi sparar dina uppgifter tills du själv begär att de raderas. Du kan när som helst:
        </p>
        <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-2">
          <li>Avregistrera dig från våra e-postutskick via Mailchimps länk i e-postfoten</li>
          <li>Kontakta oss på <a href="mailto:hej@demenshjaltar.se" className="text-minnestig-purple hover:underline">hej@demenshjaltar.se</a> för att få din information raderad eller uppdaterad</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">7. Dina rättigheter enligt GDPR</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Du har rätt att:
        </p>
        <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-2 mb-4">
          <li>Få tillgång till dina personuppgifter</li>
          <li>Be oss rätta eller ta bort uppgifter</li>
          <li>Återkalla ditt samtycke när som helst</li>
        </ul>
        <p className="text-gray-700 leading-relaxed">
          För att använda någon av dessa rättigheter, mejla oss på <a href="mailto:hej@demenshjaltar.se" className="text-minnestig-purple hover:underline">hej@demenshjaltar.se</a>
        </p>
      </section>

      <section>
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">8. Kontakt</h2>
        <p className="text-gray-700 leading-relaxed">
          Om du har frågor kring denna policy, eller hur vi hanterar personuppgifter, kontakta oss på:
          <br />
          <a href="mailto:hej@demenshjaltar.se" className="text-minnestig-purple hover:underline">hej@demenshjaltar.se</a>
        </p>
      </section>
    </div>
  );
};

export default Integritetspolicy;
